'use client';

type Props = {
  url: string;
  libraryId: string;
};

export default function BunnyCdnPlayer({ url, libraryId }: Props) {
  return (
    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
      <iframe
        src={`https://iframe.mediadelivery.net/embed/${libraryId}/${url}`}
        loading="lazy"
        style={{
          border: 'none',
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen={true}
      />
    </div>
  );
}
